//Fixed Header on Scroll

$(window).on('scroll', () => {
    if ($(window).scrollTop() > 0) {
        $('body').addClass('ll-is-scrolling')
    } else {
        $('body').removeClass('ll-is-scrolling')
    }
})

//Submenu
$('header .jq-ll-toggle-sub-menu').on('hover', e => {
    if ($(window).width() >= 1024) {
        let $this = $(e.currentTarget),
            menu = $this.find('.ll-sub-menu'),
            body = $('body')

        if (!menu.hasClass('ll-sub-menu--is-active')) {
            menu.toggleClass('ll-sub-menu--is-active')
            body.addClass('ll-sub-menu--is-active')
            $this.nextAll('.jq-ll-toggle-sub-menu').find('.ll-sub-menu').removeClass('ll-sub-menu--is-active')
            $this.prevAll('.jq-ll-toggle-sub-menu').find('.ll-sub-menu').removeClass('ll-sub-menu--is-active')
        }
    }
})

$('header .jq-ll-toggle-sub-menu').on('click', e => {
    let $this = $(e.currentTarget),
        menu = $this.find('.ll-sub-menu'),
        body = $('body')

    if ($(window).width() < 1024 && !menu.hasClass('ll-sub-menu--is-active')) {
        e.preventDefault()

        if (!menu.hasClass('ll-sub-menu--is-active')) {
            menu.toggleClass('ll-sub-menu--is-active')
            body.addClass('ll-sub-menu--is-active')
            $this.nextAll('.jq-ll-toggle-sub-menu').find('.ll-sub-menu').removeClass('ll-sub-menu--is-active')
            $this.prevAll('.jq-ll-toggle-sub-menu').find('.ll-sub-menu').removeClass('ll-sub-menu--is-active')
        }
    }
})

$('header').on('mouseleave', (e) => {
    if($(document).width() >= 1024) {
        let $this = $(e.currentTarget),
            menu = $this.find('.ll-sub-menu'),
            body = $('body')
        menu.removeClass('ll-sub-menu--is-active')
        body.removeClass('ll-sub-menu--is-active')
    }
})

$('.ll-sub-menu--back-button').on('click', function () {
    let menu = $('.ll-sub-menu'),
        body = $('body')
    menu.removeClass('ll-sub-menu--is-active')
    body.removeClass('ll-sub-menu--is-active')
})

//Mobile Menu
let menuMobile = () => {
    const menu = $('#ll-menu-header-mobile')
    const button = $('.ll-header-mobile .ll-toggle-menu')
    const header = $('.ll-header-mobile')
    const body = $('body')

    button.on('click tap', e => {
        let $this = $(e.currentTarget)
        $this.toggleClass('ll-active')
        menu.toggleClass('ll-active')
        header.toggleClass('ll-active')
        body.toggleClass('ll-mobile-menu-is-open')
    })
}

menuMobile()

//Header Height Filler
$(window).on('load', () => {
    let height = $('header').height()
    $('.ll-fixed-header-filler').css('height', height)
})



// WEBPACK FOOTER //
// ./scripts/header.js